import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import OurServices from "./sections/OurServices";
import CallToAction from "./sections/CallToAction";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Hero />
      <OurServices />
      <CallToAction />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}